import {
  Button,
  DialogActions,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';

interface Props {
  title?: string;
  description?: string | React.ReactNode;
  buttonCancelText?: string;
  buttonOkText?: string;
  open: boolean;
  handleClose: () => void;
  handleOk: () => void;
  hasActions?: boolean;
}

export const ConfirmDialog: React.FC<Props> = ({
  title = '',
  description = '',
  buttonCancelText = 'Cancel',
  buttonOkText = 'OK',
  open,
  handleClose,
  handleOk,
  hasActions = true,
}) => {
  const theme = useTheme();
  const smBelow = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Dialog fullWidth fullScreen={smBelow} open={open} onClose={handleClose}>
      <DialogTitle>
        {title}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ mb: hasActions ? 0 : 10 }}>
        {description}
      </DialogContent>

      {hasActions && (
        <DialogActions>
          <Button variant="outlined" color="secondary" onClick={handleClose}>
            {buttonCancelText}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleOk();
              handleClose();
            }}
          >
            {buttonOkText}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};
